// @ts-check
import { observer } from 'mobx-react-lite';
import React from 'react';
import { processBadgeDiscount } from 'src/scripts/templates/product-listing-page/PlpUtils/ProcessBadgeDiscount';
import { toLocalCurrency } from 'src/scripts/utils/currency';
import { heapTrack } from 'src/scripts/utils/helpers';
import { extractProductIdFromDecodedGraphQLId } from '../../../../../utils/shopify';
import type { RecommendationServiceCarouselItemTypes } from './RecommendationServiceTypes';
import { getProductPrices } from '../helpers';

let RecommendationServiceCarouselItem = ({ data, blockTitle }: RecommendationServiceCarouselItemTypes) => {
  const productPrice = Math.trunc(data.priceRange.maxVariantPrice.amount);
  const productCompareAtPrice = Math.trunc(data.compareAtPriceRange.maxVariantPrice.amount);
  const [price, compareAtPrice] = getProductPrices(data.tags, productPrice, productCompareAtPrice);

  const title = data.title;
  const handle = data.handle;
  const imgSrc = data.images[0];

  const productId = Number(extractProductIdFromDecodedGraphQLId(data.gid));
  const sendProductIdToHeap = () => {
    heapTrack(`PDP - Click - Item in Carousel`, {
      productId,
      carousel: blockTitle,
    });
  };

  const isOnSale = compareAtPrice && compareAtPrice > price;

  //const titleLength = isMobile ? 37 : 30;

  return (
    <div className="product-carousel--wrapper insta-product crosssell-product">
      <a href={`/products/${handle}`} onClick={sendProductIdToHeap}>
        <img className="img-fluid product-carousel-image" src={imgSrc || ''} alt={title} />
      </a>
      {isOnSale && compareAtPrice ? (
        <span className="product-card-badge tag-small uppercase">{processBadgeDiscount(compareAtPrice, price)}</span>
      ) : null}
      <a href={`/products/${data.handle}`} onClick={sendProductIdToHeap}>
        <p className="product-name product-carousel-title">{title}</p>
      </a>
      <span
        className={
          isOnSale
            ? 'product-price product-carousel-price product__price sale__price mr-2'
            : 'product-price product-carousel-price product__price'
        }
        data-currency
      >
        {toLocalCurrency(price)}
        {isOnSale && compareAtPrice ? (
          <span className="product__price--sale">
            <s>{toLocalCurrency(compareAtPrice)}</s>
          </span>
        ) : null}
      </span>
    </div>
  );
};
RecommendationServiceCarouselItem = observer(RecommendationServiceCarouselItem);

export default RecommendationServiceCarouselItem;
